module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Thin-45bf7f2ff279d8d2e8454e9f5d196085.svg";